import React from 'react';

import Avatar from '@atlaskit/avatar';
import AvatarItem from '@atlaskit/avatar/AvatarItem';
import { Inline } from '@atlaskit/primitives';
import { VerifiedTeamIcon } from '@atlassian/people-teams-ui/verified-team-icon';

type TeamLabelValue = {
	label: string;
	verified?: boolean;
	avatarUrl?: string;
};

export const formatTeamLabel = (teamValue: TeamLabelValue | null | undefined) => {
	if (!teamValue) {
		return null;
	}

	const shouldShowVerifiedIcon = !!teamValue.verified;

	return (
		<AvatarItem
			avatar={teamValue.avatarUrl ? <Avatar src={teamValue.avatarUrl} size="small" /> : null}
			primaryText={
				shouldShowVerifiedIcon ? (
					<Inline space="space.050" alignBlock="center">
						{teamValue.label}
						<VerifiedTeamIcon />
					</Inline>
				) : (
					teamValue.label
				)
			}
		/>
	);
};
